import React from 'react';
import Layout from '../../components/Layout';
import CheckinPage from '../../components/Inspection/CheckinPage';
import NotFound from '../notFound/NotFound';
import messages from '../../locale/jsonMessages';

// /checkin/:reservationId — logged in users only. The page itself checks the role (owner or renter of the reservation), the
// reservation state and the time window with the server and explains why it cannot be used.
export default async function action({ store, params, intl }) {
  const title = intl?.formatMessage(messages.inspCheckinTitle);

  // From Redux Store
  const isAuthenticated = store.getState().runtime.isAuthenticated;
  const reservationId = Number(params.reservationId);

  if (!isAuthenticated) {
    return { redirect: '/login' };
  }

  if (!Number.isInteger(reservationId) || reservationId <= 0) {
    return {
      title,
      component: <Layout><NotFound title={title} /></Layout>,
      status: 404
    };
  }

  return {
    title,
    component: <Layout><CheckinPage reservationId={reservationId} /></Layout>,
  };
};
